import { render, staticRenderFns } from "./CalendarEventForm.vue?vue&type=template&id=1b0740f8&"
import script from "./CalendarEventForm.vue?vue&type=script&lang=js&"
export * from "./CalendarEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports